import request from '@/utils/request'

export function getListMaterialQuantificationApi(query) {
  return request({
    url: '/config-service/v1/quantitative-declaration/list',
    method: 'get',
    params: query
  })
}

export function getAllMaterial(query) {
  return request({
    url: '/config-service/v1/quantitative-declaration',
    method: 'get',
    params: query
  })
}

export function addMaterialQuantificationApi(query, id) {
  return request({
    url: `/config-service/v1/quantitative-declaration?finishProductId=${id}`,
    method: 'post',
    data: query
    // params: {
    //   finish_product_id: id
    // }
  })
}

export function updateMaterialQuantificationApi(query) {
  return request({
    url: `/config-service/v1/quantitative-declaration/${query.id}`,
    method: 'put',
    data: query
  })
}

export function deleteMaterialQuantificationApi(query) {
  return request({
    url: '/config-service/v1/quantitative-declaration',
    method: 'delete',
    data: query
  })
}

export function getMaterialQuantificationTemplateApi(query) {
  return request({
    url: '/config-service/v1/quantitative-declaration/excel-template',
    method: 'get',
    params: query,
    responseType: 'arraybuffer'
  })
}

export function addMaterialQuantificationExcelApi(data) {
  return request({
    url: '/config-service/v1/quantitative-declaration/excel',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
